import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const MyProgressBar = ({ percentage = 66, progress }) => {
    return (
        <div style={{
            ...overlayStyle,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            padding: '20px'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: '8px',
                padding: '10px',
            }}>
                <div style={{ marginBottom: '20px', width: '100px', height: '100px' }}>
                    <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                        styles={buildStyles({
                            pathColor: 'orange',
                            textColor: '#fff',
                            trailColor: '#444',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)'
                        })}
                    />
                </div>
                <div className=' rounded p-2 py-0 my-0  border d-flex gap-2'>
                    <div className='d-flex justify-content-between mb-1'>
                        <span className='text-light fw-bold'>Processed : </span>
                        <span className=' fw-bold' style={{ color: 'lightblue' }}>&nbsp;{progress.processed}/{progress.total}</span>
                    </div>
                    <div className='d-flex justify-content-between mb-1'>
                        <span className='text-light fw-bold'>Success : </span>
                        <span className='text-success fw-bold'>&nbsp;{progress.successCount}</span>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <span className='text-light fw-bold'>Error : </span>
                        <span className='text-danger fw-bold'>&nbsp;{progress.errorCount}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
};
export default MyProgressBar;